/* eslint-disable camelcase */
import moment from 'moment';

const UnitOfTime = {
  Month: 'month',
  Week: 'week',
  Weeks: 'weeks',
  Day: 'day',
  Days: 'days',
  Year: 'year',
};

/** Get events dates list by year
 * @param {*} startEventDate - init date for event
 * @param {*} endEventDate - end date for event
 */
export const getEventDatesByYear = (startEventDate, endEventDate) => {
  const eventDateList = [];
  const currentDateIndex = moment(startEventDate.toString());
  const endDateIndex = moment(endEventDate.toString());
  console.log({ startYearDate: startEventDate.toString(), endYearDate: endEventDate.toString() });

  while (currentDateIndex < endDateIndex) {
    const tempDate = currentDateIndex.format('YYYY-MM-DD');
    eventDateList.push(tempDate);
    currentDateIndex.add(1, 'year');
  }
  console.log(eventDateList);
  return eventDateList;
};

/** Get events dates list by mounth
 * @param {*} startEventDate - init date for event
 * @param {*} endEventDate - end date for event
 * @param {*} repeatEveryCount - number of times to repeat event
 * */
export const getEventDatesByMonth = (startEventDate, endEventDate, repeatEveryCount) => {
  const eventDateList = [];

  const currentDateIndex = moment(startEventDate.toString());
  const endDateIndex = moment(endEventDate.toString());
  console.log({ startMonthDate: startEventDate.toString(), endMonthDate: endEventDate.toString() });

  while (currentDateIndex <= endDateIndex) {
    const tempDate = currentDateIndex.format('YYYY-MM-DD');
    eventDateList.push(tempDate);
    currentDateIndex.add(repeatEveryCount, 'month');
  }
  console.log(eventDateList);
  return eventDateList;
};

/** Get events dates list by week and day */
const getDatesInOneWeek = (startRecurenceDate, dayList, endRecurrent, interval) => {
  const dateList = [];

  const currentWeekDate = moment(startRecurenceDate.toString());
  const currentEndWeekDate = moment(startRecurenceDate.toString()).endOf(UnitOfTime.Week);
  const endRecurrentDate = moment(endRecurrent.toString());

  console.log(`[startEventDate] -> ${currentWeekDate.toString()}`);
  do {
    if (currentWeekDate > endRecurrentDate) break;

    const dayWeekNumber = moment(currentWeekDate.toString()).isoWeekday();

    if (dayList.includes(dayWeekNumber)) {
      dateList.push(currentWeekDate.format('YYYY-MM-DD'));
      console.log('[+]', currentWeekDate.toString());
    } else console.log('[-]', currentWeekDate.toString());

    currentWeekDate.add(interval, 'day');
  } while (currentWeekDate <= currentEndWeekDate); // Condition for finish weeks
  console.log(`[endWeekDate] -> ${currentEndWeekDate.toString()}\n`);
  return dateList;
};
/**
 * @param {*} startEventDate
 * @param {*} endEventDate
 * @param {*} repeatEveryCount
 * @param {*} dayList
 */
export const getEventDatesByWeek = (startEventDate, endEventDate, repeatEveryCount, dayList) => {
  let eventDateList = [];
  const startIndex = moment(startEventDate);
  const endIndex = moment(endEventDate);
  console.log({ initWeek: startEventDate.toString(), eventDateList });

  while (startIndex < endIndex) {
    const evenDateWeekList = getDatesInOneWeek(startIndex, dayList, endEventDate, 1);
    eventDateList = [...eventDateList, ...evenDateWeekList];
    startIndex.add(repeatEveryCount, UnitOfTime.Week);
    startIndex.startOf(UnitOfTime.Week);
    console.log({ initWeek: startIndex.toString(), eventDateList });
  }
  return eventDateList;
};

export const getEventDatesByDays = (startEventDate, endEventDate, repeatEveryCount, dayList) => {
  let eventDateList = [];
  const startIndex = moment(startEventDate);
  const endIndex = moment(endEventDate);
  console.log({ initWeek: startEventDate.toString(), eventDateList });

  while (startIndex < endIndex) {
    const evenDateWeekList = getDatesInOneWeek(startIndex, dayList, endEventDate, repeatEveryCount);
    eventDateList = [...eventDateList, ...evenDateWeekList];
    startIndex.add(1, UnitOfTime.Week);
    startIndex.startOf(UnitOfTime.Week);
    console.log({ initWeek: startIndex.toString(), eventDateList });
  }
  return eventDateList;
};
